'use strict'

import Axios, { AxiosInstance } from "axios";
import { Workflow } from '@/models/workflow';

export class WorkflowService {
  private _api!: AxiosInstance;

  constructor() {
    this._api = Axios.create({
      baseURL: process.env.VUE_APP_ECE_API_URL,
      responseType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'x-api-key': 'eaQSPYWOqAbDOpjX3zFC2bDJvh6z7wB3wV888d25'
      }
    });
  }

  async get(workflowId: string): Promise<Workflow> {
    const response = await this._api.get<Workflow>(`/Workflow/${workflowId}?nocache=${new Date().getTime()}`);
    return response.data;
  }

  async create(workflow: Workflow): Promise<Workflow> {
    const response =  await this._api.post<Workflow>('Workflow', workflow)
    return response.data;
  }

  async update(workflowId: string, workflow: Workflow): Promise<Workflow> {
    const response = await this._api.put<Workflow>(`/Workflow/${workflowId}`, workflow)
    return response.data;
  }

  async putWebStep(workflowId: string, step: string): Promise<boolean> {
    const data = {
      step: step
    }
    const response = await this._api.put<boolean>(`/Workflow/${workflowId}/WebStep`, data)
    return response.data;
  }

  async publishWebCDCClickEvent(workflowId: string): Promise<boolean> {
    const response = await this._api.put<boolean>(`/Workflow/${workflowId}/CDCClick`)
    return response.data;
  }

  async publishWebLearnMoreClickEvent(workflowId: string): Promise<boolean> {
    const response = await this._api.put<boolean>(`/Workflow/${workflowId}/LearnMoreClick`)
    return response.data;
  }
}
